import _classCallCheck from "/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var TinyQueue = /*#__PURE__*/function () {
  function TinyQueue() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var compare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCompare;

    _classCallCheck(this, TinyQueue);

    this.data = data;
    this.length = this.data.length;
    this.compare = compare;

    if (this.length > 0) {
      for (var i = (this.length >> 1) - 1; i >= 0; i--) {
        this._down(i);
      }
    }
  }

  _createClass(TinyQueue, [{
    key: "push",
    value: function push(item) {
      this.data.push(item);
      this.length++;

      this._up(this.length - 1);
    }
  }, {
    key: "pop",
    value: function pop() {
      if (this.length === 0) return undefined;
      var top = this.data[0];
      var bottom = this.data.pop();
      this.length--;

      if (this.length > 0) {
        this.data[0] = bottom;

        this._down(0);
      }

      return top;
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.data[0];
    }
  }, {
    key: "_up",
    value: function _up(pos) {
      var data = this.data,
          compare = this.compare;
      var item = data[pos];

      while (pos > 0) {
        var parent = pos - 1 >> 1;
        var current = data[parent];
        if (compare(item, current) >= 0) break;
        data[pos] = current;
        pos = parent;
      }

      data[pos] = item;
    }
  }, {
    key: "_down",
    value: function _down(pos) {
      var data = this.data,
          compare = this.compare;
      var halfLength = this.length >> 1;
      var item = data[pos];

      while (pos < halfLength) {
        var left = (pos << 1) + 1;
        var best = data[left];
        var right = left + 1;

        if (right < this.length && compare(data[right], best) < 0) {
          left = right;
          best = data[right];
        }

        if (compare(best, item) >= 0) break;
        data[pos] = best;
        pos = left;
      }

      data[pos] = item;
    }
  }]);

  return TinyQueue;
}();

export { TinyQueue as default };

function defaultCompare(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}